import { http } from 'apsis-plugin';
import { get } from 'lodash';

// send login data and retrive a new token
export const postLogin = ({ userId, password }) => http.post('/auth/token/issue', { userId, password })
  .then((response) => get(response, 'data'));

// get current user's data
export const loadUserData = () => http.get('/auth/me').then((response) => get(response, 'data'));

// revoke current token
export const revokeToken = () => http.post('/auth/token/revoke').then((response) => get(response, 'data'));

// buscar avisos
export const buscaAvisos = () => http.get('/avisos/inicio').then((response) => get(response, 'data'));

// check beneficiario atualizado
export const beneficiarioRequerAtualizacao = () => http.get('beneficiarios/beneficiario-logado-requer-atualizacao-cadastral').then((response) => get(response, 'data'));
